import { useEffect, useRef, useState } from "react";

export function useDetectOutsideClick(onClickOutside: () => void) {
    const [listening, setListening] = useState(false);
    const targetRef = useRef(null);

    useEffect(() => {
        if (listening || !targetRef.current) {
            return;
        }
        setListening(true);
        document.addEventListener("click", function callback(event) {
            if (!targetRef.current) {
                document.removeEventListener("click", callback);
                return;
            } else if (targetRef.current.contains(event.target)) {
                return;
            }
            onClickOutside();
        });
    });

    return targetRef;
}
